// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"content_outerContainer__AR8OX","header":"content_header__34ZDx","container":"content_container__QVbqa"};